module.exports = __webpack_public_path__ + "img/success-academy-products.67807119.png";